// extracted by mini-css-extract-plugin
export var container = "CardList-module--container--2EU62";
export var list = "CardList-module--list--3c6A3";
export var item = "CardList-module--item--2-hHy";
export var imageContainer = "CardList-module--imageContainer--20YTW";
export var videoUpload = "CardList-module--videoUpload--dHQBy";
export var title = "CardList-module--title--3zu5M";
export var description = "CardList-module--description--39-Pp";
export var linkContainer = "CardList-module--linkContainer--1g8WK";
export var cardList3 = "CardList-module--cardList3--Bzu_C";
export var cardListOnSurface = "CardList-module--cardListOnSurface--2QhQx";
export var show = "CardList-module--show--c3dk2";
export var showFadeInDown = "CardList-module--show-fade-in-down--oxb8l";
export var showFadeInUp = "CardList-module--show-fade-in-up--2EiCQ";
export var hideFadeOut = "CardList-module--hide-fade-out--29OE4";